import i18n from './i18n'
import { configure } from 'vee-validate'
configure({
  // this will be used to generate messages.

  defaultMessage (field, values) {
    values._field_ = field
    return i18n.t(`validations.${values._rule_}`, values)
  }
})
